import { axiosInstance } from '../../../api'
import { UserNotification } from '../../../store/notifications/types'

export type GetNotificationsParams = {
  userId: number
}

export const notificationsApi = {
  //Get Notifications
  async getNotifications(
    params: GetNotificationsParams
  ): Promise<UserNotification[]> {
    try {
      const response = await axiosInstance.get(
        `user-notifications/${params.userId}`
      )
      return response.data
    } catch (error) {
      throw new Error('Failed to fetch notifications')
    }
  },

  //Mark as reviewed
  async markAsReviewed(userNotificationId: number): Promise<void> {
    try {
      await axiosInstance.post(
        `user-notifications/${userNotificationId}/reviewed`
      )
    } catch (error) {
      throw new Error('Failed to mark notification as reviewed')
    }
  },

  async getAllNotifications(userId: number): Promise<UserNotification[]> {
    try {
      const response = await axiosInstance.get(`user-notifications/${userId}`)
      return response.data
    } catch (error) {
      throw new Error('Failed to fetch notifications')
    }
  },
}
